import React from "react";
import VerifiedIcon from "../../../../icons/PostYourProperty/VerifiedIcon";
import { Button } from "../../../../shadcn/components/ui/button";

interface HorizontalStepperProps {
  activeStep: number;
  totalSteps: number;
  setActiveStep: any;
  stepsTitles: { label: string; value: string }[];
  styles?: {
    outerContainer?: string;
  };
}

export default function HorizontalStepper({
  activeStep,
  totalSteps,
  setActiveStep,
  stepsTitles,
  styles,
}: HorizontalStepperProps) {
  return (
    <div className={`flex w-full ${styles?.outerContainer}`}>
      <ul className="flex justify-between w-full">
        {Array.from({ length: totalSteps }, (_, index) => (
          <li
            className={` ${index + 1 == totalSteps ? "" : "flex-1"} `}
            key={index}
          >
            <div className="flex items-start">
              {activeStep > index ? (
                <div
                  className="hover:cursor-pointer h-fit"
                  // onClick={() => {
                  //   setActiveStep(index);
                  // }}
                >
                  <VerifiedIcon
                    fill="#BC99FF"
                    className="h-[17px] w-[17px] sm:h-[26px] sm:w-[26px]"
                  />
                </div>
              ) : (
                <Button
                  variant={"custom"}
                  size={"custom"}
                  className={`rounded-full bg-transparent border ${
                    activeStep === index
                      ? "border-brand-bgBlack border-[0.5px]"
                      : "border-[#BC99FF] border-[0.5px]"
                  } min-h-[16px] min-w-[16px]  sm:min-h-[26px] sm:min-w-[26px]`}
                >
                  {activeStep === index && (
                    <div className="rounded-full bg-black h-2 w-2 sm:h-3 sm:w-3"></div>
                  )}
                </Button>
              )}
              <div
                className={`border-t-[1px] mt-2 sm:mt-3 w-full mx-[6px] ${
                  index + 1 === totalSteps
                    ? "hidden"
                    : activeStep > index
                    ? "border-[#5D5FEF]"
                    : "border-[#eee]"
                }`}
              />
            </div>
            <div
              // onClick={() => {
              //   if (activeStep > index) setActiveStep(index);
              // }}
              className="mt-3 -translate-y-[6px] hover:cursor-pointer"
            >
              <p
                className={`font-openSans md:font-semibold text-[7px] sm:text-[9px] md:text-[11px] uppercase ${
                  activeStep === index
                    ? "text-brand-bgBlack"
                    : "text-brand-borderGrey"
                } `}
              >{`Step ${index + 1}`}</p>
              <p
                className={`font-openSans text-[6px] sm:text-[10px] md:text-sm md:font-semibold sm:leading-4 lg:leading-7 ${
                  activeStep + 1 > index
                    ? "text-brand-bgBlack"
                    : "text-brand-textLightGrey"
                }  `}
              >
                {stepsTitles ? stepsTitles[index].label : "Add Details"}
              </p>
              <p
                className={`font-openSans text-[9px] md:text-xs capitalize hidden sm:inline-block ${
                  activeStep >= index
                    ? "text-[#BC99FF]"
                    : "text-brand-borderGrey"
                } `}
              >{`${
                activeStep === index
                  ? "In progress"
                  : activeStep > index
                  ? "Completed"
                  : "Pending"
              }`}</p>
            </div>
          </li>
        ))}{" "}
      </ul>
    </div>
  );
}
